import * as core from '../../../../../../../core'

import { query } from './traceability-matrix-partial.query'

export const RESOURCE = {
  payload: {
    alias: 'traceability-matrix.partial',
    description: 'Count of requirements with failing or skipped tests',
    name: 'Traceability Matrix - Partial',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
